const step_up = {
    verify_your_identity: 'Verify your identity',
    choose_method_description: 'For your security, confirm it’s you with one of these methods. You’ll then continue right where you left off.',
    password: 'Password',
    password_description: 'Enter your account password',
    enter_password_description: 'For your security, enter your account password. You’ll then continue right where you left off.',
    enter_verification_code_description: 'Enter the verification code sent to {{identifier}}. You’ll then continue right where you left off.',
    subject_proof_description: 'To continue, confirm it’s you through an account linked to yours. You can then set up a verification method.',
    subject_mismatch: 'Account doesn’t match',
    subject_mismatch_description: 'The account you used isn’t linked to your account. Use a linked account, and switch accounts at the provider if needed.',
    no_method_available: 'No verification method available',
    no_method_available_description: 'Your account has no method that can complete this verification, so nothing was changed. Add a verification method in your account settings, then try again. If that isn’t possible, contact support.',
    load_failed: 'We couldn’t load this verification. Check your connection and try again.',
    try_again: 'Try again',
    return_to_app: 'Return to the app',
};
export default Object.freeze(step_up);
